import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import { t } from '../../../services/i18nService';
import { internationalizationPrefix } from '../../../services/idverification/IdVerificationConstants';
import capturedPhotoCheckpointSelector from '../../../services/idverification/CapturedPhotoCheckpointSelector';

import CapturedPhotoCheckpointNavigationButton from './CapturedPhotoCheckpointNavigationButton';
import CheckpointErrorDisplay from './CheckpointErrorDisplay';
import CheckpointStatus from './CheckpointStatus';
import RelaxedNextButton from '../idcard/RelaxedNextButton';

import styles from './capturedevice.scss';

class PureCapturedPhotoCheckpoint extends React.PureComponent {
    static propTypes = {
        loading: PropTypes.bool,
        onNext: PropTypes.func.isRequired,
        showRelaxedButton: PropTypes.bool.isRequired,
        status: PropTypes.string,
        successful: PropTypes.bool,
    };

    static defaultProps = {
        status: null,
        successful: false,
        loading: false,
    };

    render() {
        const {
            loading,
            showRelaxedButton,
            status,
            successful,
        } = this.props;

        const NavigationButton = (showRelaxedButton)
            ? RelaxedNextButton
            : CapturedPhotoCheckpointNavigationButton;

        // Safe because undefined & null evaluates to false AND propTypes
        // enforces status to be a string.
        if (!status) {
            return null;
        }

        if (loading) {
            return (
                <CheckpointStatus className="loading">
                    {t(internationalizationPrefix + status)}
                </CheckpointStatus>
            );
        }

        return (
            <React.Fragment>
                <CheckpointStatus
                    className={successful ? 'successful' : 'error'}
                >
                    <CheckpointErrorDisplay
                        approved={successful}
                        status={status}
                    />
                </CheckpointStatus>
                <p className={styles.buttonWrapper}>
                    <NavigationButton
                        approved={successful}
                        onNext={this.props.onNext}
                    />
                </p>
            </React.Fragment>
        );
    }
}

function mapStateToProps(state) {
    return capturedPhotoCheckpointSelector.mapStateToProps(state);
}

const CapturedPhotoCheckpoint = connect(mapStateToProps)(
    PureCapturedPhotoCheckpoint
);

export { PureCapturedPhotoCheckpoint };
export default CapturedPhotoCheckpoint;
